import { useQuery } from "@tanstack/react-query"

import { useApiContext } from "@/hooks/api/use-api-context"

import { fetchDocumentFillerRun, fetchDocumentFillTemplates } from "./api"

export function useDocumentFillTemplates(householdId: string) {
  const getContext = useApiContext()

  return useQuery({
    queryKey: ["household", householdId, "document-fill-templates"],
    queryFn: async () => {
      const context = await getContext()
      if (!context) throw new Error("No context found")
      return fetchDocumentFillTemplates(context, householdId)
    },
    enabled: !!householdId,
  })
}

export function useDocumentFillerRun(id: string | null) {
  const getContext = useApiContext()

  return useQuery({
    queryKey: ["document-filler-run", id],
    queryFn: async () => {
      const context = await getContext()
      if (!context) throw new Error("No context found")
      return fetchDocumentFillerRun(context, id!)
    },
    enabled: !!id,
    refetchInterval: (query) => {
      const run = query.state.data
      if (!run || run.status === "completed" || run.status === "failed") return false
      return 3000
    },
  })
}
